module.exports = new __parcel__URL__("ivan-ros-navarro.e43163cf.jpg").toString();